// import * as jwt from "jsonwebtoken";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import { apiService } from "./apiService";
import handleUnauthorizedError, {
  retryAllPendingRequest,
} from "./handleUnauthorizedError";

const sessionName = {
  MENTAL: "session_mental",
  MENTAL_DOCTOR: "session_mental_doctor",
};

let session = null;
let gettingNewToken = false;

const checkSession = async () => {
  if (session) {
    return checkSessionByName(session.name);
  } else {
    return checkSessionByName(sessionName.MENTAL);
  }
};

const checkSessionByName = async (name, navigate, redirectPath) => {
  const sessionData = Cookies.get(name);
  session = sessionData ? JSON.parse(sessionData) : null;
  if (!session || session.name !== name) {
    if (navigate) navigate(redirectPath);
    return null;
  }

  let decoded = jwt_decode(session.refresh_token);
  let expire = decoded["exp"] * 1000;
  // check session expire
  if (expire > Date.now()) {
    return session;
  }
  await refreshSession();

  if (!session && navigate) {
    navigate(redirectPath);
  }

  return session;
};

const refreshSession = async () => {
  if (!session) return;

  // refresh session
  switch (session.name) {
    case sessionName.MENTAL_DOCTOR:
      await refreshUserToken();
      break;
    default:
      break;
  }
};

const setSessionByName = (name, s) => {
  s.name = name;
  Cookies.set(name, JSON.stringify(s));
  session = s;
};

const clearSession = () => {
  if (!session) return;
  clearSessionByName(session.name);
};

const clearSessionByName = (name) => {
  Cookies.remove(name);
  session = null;
};

const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const refreshUserToken = async () => {
  if (!session || gettingNewToken) {
    // localStorage.removeItem("user");
    return;
  }
  gettingNewToken = true;

  let req = { refresh: session.refresh_token };
  await apiService
    .post(`/auth/refresh-token`, req)
    .then(async (response) => {
      let responseData = response.data;
      const sessionData = {
        access_token: responseData.access,
        refresh_token: responseData.refresh,
      };
      setSessionByName(session.name, sessionData);
      retryAllPendingRequest();
      await sleep(1000);
    })
    .catch((error) => {
      handleUnauthorizedError(error, refreshUserToken);
    });
  gettingNewToken = false;
};

var authHeader = () => {
  return session
    ? {
        headers: {
          Authorization: "JWT " + session.access_token,
          "Content-Type": "application/json",
        },
      }
    : {
        headers: {
          "Content-Type": "application/json",
        },
      };
};

export {
  authHeader,
  checkSession,
  checkSessionByName,
  refreshSession,
  setSessionByName,
  clearSession,
  clearSessionByName,
  session,
  sessionName,
};
